import {CAR_SERVICE, LONG_TERM, NEW_CAR, PROMISCUOUS, SHARING, SHORT_TERM} from "./FuelsConstants";
import {useTranslation} from "react-i18next";


export const useRegistryFuelCardUse = () => {

    const {t} = useTranslation(['finance'], {keyPrefix: 'registryFuelCard.filters.cardUseList'});


    const getRegistryFuelCardUse = (cardUseList: string) => {
        switch (cardUseList) {

            case PROMISCUOUS:  return t('PROMISCUOUS');
            case NEW_CAR:      return t('NEW_CAR');
            case CAR_SERVICE:  return t('CAR_SERVICE');

            default : return '-'
        }
    };

    const cardUseList = [
        {
            value: PROMISCUOUS,
            label: getRegistryFuelCardUse(PROMISCUOUS)
        },
        {
            value: NEW_CAR,
            label: getRegistryFuelCardUse(NEW_CAR)
        },
        {
            value: CAR_SERVICE,
            label: getRegistryFuelCardUse(CAR_SERVICE)
        }
    ];

    return {
        cardUseList, getRegistryFuelCardUse
    }
}